'use client';

import React from 'react';

import Profile from '@/components/common/Profile';
import { UserModel } from '@/types/users';
import { TeamMemberGlobalContextModel } from '@/types/teams';

interface ProfileModalProps {
  propsUser: UserModel;
  propsUserTeams: TeamMemberGlobalContextModel[] | undefined;
  closeModal: () => void;
}

/**
 * プロフィールモーダル
 * @param param0
 * @returns
 */
const ProfileModal: React.FC<ProfileModalProps> = ({ closeModal, propsUser, propsUserTeams }) => {
  /**
   * モーダルクローズ（背景押下）
   */
  const handleModalClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // モーダルの背景をクリックした場合にだけ closeModal を呼び出す
    const modalBackground = document.getElementById('modal-background');
    if (e.target === modalBackground) {
      closeModal();
    }
  };

  return (
    <>
      <div
        tabIndex={-1}
        id="modal-background"
        aria-hidden="true"
        className="fixed inset-0 z-30 w-full flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
        onClick={handleModalClick}>
        <div className="fixed z-50 top-0 right-0 flex items-center justify-between p-2">
          <button
            type="button"
            className="text-gray-300 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
            data-modal-hide="tacticalboard-modal"
            onClick={closeModal}>
            <svg
              className="w-6 h-6"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14">
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">Close modal</span>
          </button>
        </div>
        <div className="w-11/12 lg:w-6/12 rounded-lg">
          <Profile propsFootballer={propsUser} propsUserTeams={propsUserTeams} />
        </div>
      </div>
    </>
  );
};

export default ProfileModal;
